"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var components_1 = require("@athena-portal/components");
var Confirmation_1 = require("../../Confirmation");
var Tree_1 = require("../../../components/Tree");
var ToggleAutomaticRenewalAction = /** @class */ (function (_super) {
    __extends(ToggleAutomaticRenewalAction, _super);
    function ToggleAutomaticRenewalAction(props) {
        var _this = _super.call(this, props) || this;
        _this.updateAutoRenewalFlag = function () {
            _this.supportPortalService
                .setAutomaticRenewalFlag(_this.props.customerReferenceNumber, _this.props.policyNumber, !_this.state.autoRenewalFlag)
                .subscribe(function (response) {
                if (!(response instanceof Error)) {
                    _this.setState({
                        performRenewalFlag: (_this.state.performRenewalFlag !== _this.state.autoRenewalFlag) ? !_this.state.autoRenewalFlag : !_this.state.performRenewalFlag,
                        autoRenewalFlag: !_this.state.autoRenewalFlag,
                    });
                    _this.props.parentCallback(_this.state.autoRenewalFlag, _this.state.performRenewalFlag);
                }
            });
            _this.supportPortalService.logAgentActivity(_this.props.customerReferenceNumber, { "action": "Update auto renewal to ".concat(_this.state.autoRenewalFlag ? "Off" : "On"), "customer": _this.props.policyNumber }).subscribe();
            _this.setState({ showAutoRenewalConfirmation: false });
        };
        _this.updatePerformRenewalFlag = function () {
            _this.supportPortalService
                .setPerformRenewalFlag(_this.props.customerReferenceNumber, _this.props.policyNumber, !_this.state.performRenewalFlag)
                .subscribe(function (response) {
                if (!(response instanceof Error)) {
                    _this.setState({
                        performRenewalFlag: !_this.state.performRenewalFlag
                    });
                    _this.props.parentCallback(_this.state.autoRenewalFlag, _this.state.performRenewalFlag);
                }
            });
            _this.setState({ showPerformRenewalConfirmation: false });
        };
        _this.state = {
            showAutoRenewalConfirmation: false,
            autoRenewalFlag: _this.props.autoRenewalFlag,
            showPerformRenewalConfirmation: false,
            performRenewalFlag: _this.props.performRenewalFlag
        };
        return _this;
    }
    ToggleAutomaticRenewalAction.prototype.render = function () {
        var _this = this;
        var result = null;
        if (!this.props.isMTC) {
            result = (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline", onClick: function () { return _this.setState({ showAutoRenewalConfirmation: true }); }, children: "Update Automatic Renewal Marker from ".concat(this.getFlagStateStringValue(this.state.autoRenewalFlag), " to ").concat(this.getFlagStateStringValue(!this.state.autoRenewalFlag)) }), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: this.state.showAutoRenewalConfirmation, hide: function () { return _this.setState({ showAutoRenewalConfirmation: false }); }, confirm: function () { return _this.updateAutoRenewalFlag(); }, title: "", message: "Are you sure you want to update automatic renewal marker to ".concat(this.state.autoRenewalFlag ? "Off" : "On") }), (this.props.hasPendingRenewalVersion && (this.state.performRenewalFlag !== this.state.autoRenewalFlag)) &&
                            (0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline", onClick: function () { return _this.setState({ showPerformRenewalConfirmation: true }); }, children: "Update This Year\u2019s Renewal Marker from ".concat(this.getFlagStateStringValue(this.state.performRenewalFlag), " to ").concat(this.getFlagStateStringValue(!this.state.performRenewalFlag)) }), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: this.state.showPerformRenewalConfirmation, hide: function () { return _this.setState({ showPerformRenewalConfirmation: false }); }, confirm: function () { return _this.updatePerformRenewalFlag(); }, title: "", message: "Are you sure you want to update perform renewal marker to ".concat(this.state.performRenewalFlag ? "Off" : "On") })] }) });
        }
        return result;
    };
    ToggleAutomaticRenewalAction.prototype.getFlagStateStringValue = function (flag) {
        return flag ? "On" : "Off";
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], ToggleAutomaticRenewalAction.prototype, "supportPortalService", void 0);
    ToggleAutomaticRenewalAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead", "CSR", "Support"),
        __metadata("design:paramtypes", [Object])
    ], ToggleAutomaticRenewalAction);
    return ToggleAutomaticRenewalAction;
}(React.Component));
exports.default = ToggleAutomaticRenewalAction;
//# sourceMappingURL=ToggleAutomaticRenewalAction.js.map